export default __webpack_public_path__ + "static/media/banner.84ca1d52.jpg";